import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoaderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 73,
	viewBox: "0 0 72 73",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M67.5697 38.2272C69.9983 38.3313 71.9101 40.3928 71.5107 42.7906C70.5894 48.3211 68.3851 53.5813 65.0496 58.1382C60.8441 63.8836 55.0294 68.253 48.3407 70.6937C41.652 73.1345 34.3897 73.537 27.4722 71.8504C20.5547 70.1637 14.2927 66.4637 9.47812 61.2182C4.6635 55.9726 1.51247 49.4172 0.423522 42.3808C-0.665429 35.3445 0.356597 28.1432 3.36036 21.6877C6.36412 15.2322 11.2147 9.81237 17.2987 6.11361C22.1242 3.18002 27.5536 1.43357 33.1426 0.988552C35.5657 0.795614 37.4563 2.87672 37.3522 5.3053V5.3053C37.2482 7.73387 35.184 9.58145 32.7704 9.87011C28.9268 10.3298 25.2081 11.6069 21.8716 13.6354C17.2752 16.4297 13.6107 20.5243 11.3414 25.4013C9.0721 30.2783 8.29998 35.7187 9.12266 41.0346C9.94534 46.3504 12.3259 51.3029 15.9632 55.2658C19.6006 59.2287 24.3314 62.024 29.5574 63.2982C34.7834 64.5724 40.2699 64.2684 45.3231 62.4244C50.3763 60.5805 54.7693 57.2795 57.9464 52.9389C60.2527 49.788 61.8432 46.1921 62.6298 42.4019C63.1238 40.0218 65.1411 38.1232 67.5697 38.2272V38.2272Z",
		fill: "url(#paint0_linear_9992_30293)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_9992_30293",
		x1: 58.0655,
		y1: 65.1966,
		x2: -11.6126,
		y2: 22.7827,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				stopColor: "#FFBBBB",
				stopOpacity: .2
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .495,
				stopColor: "#FF8383",
				stopOpacity: .612
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF4E4E"
			})
		]
	}) })]
});
export default SvgLoaderIcon;
